import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Tokens, User } from '../../services';

export type AuthState = {
  tokens: Tokens | null;
  signed: boolean;
  user: User | null;
  menuSelected: 'account' | 'portal' | 'logs' | 'profile';
  setUser: (user: User) => void;
  setUserAuthenticated: (user: User, tokens: Tokens) => void;
  signOut: () => void;
  setMenuSelected: (menu: 'account' | 'portal' | 'logs' | 'profile') => void;
};

const useAuthStore = create(
  persist<AuthState>(
    set =>
      ({
        tokens: null,
        signed: false,
        menuSelected: 'portal',
        setUser: (user: User) => set({ user }),
        setUserAuthenticated: (user: User, tokens: Tokens) =>
          set({
            signed: true,
            user,
            tokens,
          }),
        signOut: () =>
          set({
            signed: false,
            user: null,
            tokens: null,
          }),
        setMenuSelected: (menu: 'account' | 'portal' | 'logs' | 'profile') =>
          set({
            menuSelected: menu,
          }),
      } as AuthState),
    {
      name: '@tenGovUseAuthStore',
    },
  ),
);

export default useAuthStore;
